import { getEntitiesById } from './http/access-ws/entity';
import type { UseQueryOptions } from '@tanstack/react-query';
import type {
    DisambiguatedFirm,
    DisambiguatedGroup,
    DisambiguatedUser,
    Entity,
} from '@thinkalpha/ui-types/types/admin/index';

const SUBJECTS = 'subjects';

export const getEntitiesByIdsQuery = (
    ids: Array<string>,
): UseQueryOptions<Array<Entity>, Error, Array<DisambiguatedFirm | DisambiguatedGroup | DisambiguatedUser>> => {
    return {
        queryKey: [SUBJECTS, ids],
        queryFn: () => getEntitiesById(ids),
        select: (subjects) => subjects.filter((s) => s.type !== 'firm-membership'),
        enabled: Boolean(ids.length),
    };
};
